import Vue from 'vue'
import Router from 'vue-router'
import vueSelect from 'vue-select2'
import Select2 from 'v-select2-component';
import axios from 'axios'
//middlewares
//import guest from './middlewares/guest'
import auth from './middlewares/auth'
import animate from 'vue2-animate/dist/vue2-animate.min.css';

Vue.use(Router);
Vue.use(animate);
Vue.use(axios)

/***************** components imports  ************************/
import Blank from '../components/Blank.vue'
import Home from '../components/administrators/Home.vue'
import Sidebar from '../components/layouts/Sidebar.vue'
import AdminSidebar from '../components/layouts/components/AdminSidebar.vue'
import MarchandSidebar from '../components/layouts/components/MarchandSidebar.vue'

import TopSidebar from '../components/layouts/TopSidebar.vue'
import Login from '../components/auth/Login.vue'
import PasswordReset from '../components/auth/PasswordReset.vue'
import Register from '../components/auth/Register.vue'
import PasswordForget from '../components/auth/PassworForget.vue'
import Country from '../components/administrators/Country.vue'
import Region from '../components/administrators/Region.vue'
import Ville from '../components/administrators/Ville.vue'
import CategoryMarchands from '../components/intram-business/CategoryMarchands.vue'
import StateMarchands from '../components/administrators/StateMarchands.vue'
import Marchands from '../components/administrators/components/settings/Marchands.vue'
import ListMarchands from '../components/administrators/ListMarchand.vue'
import Documents from '../components/administrators/Documents.vue'
import Reglages from '../components/administrators/Reglages.vue'
import Langues from '../components/administrators/Langues'
import Roles from '../components/administrators/Roles'
import Users from '../components/administrators/Users'
import Devises from '../components/administrators/Devise'
import MeanPaiment from '../components/administrators/MeanPaiement'
import UserMeansPaiements from '../components/administrators/UserMeansPaiments'
import ReversementConfig from '../components/administrators/ReversementConfig'
import RechargeAccount from '../components/administrators/RechargeAccount'
import Template from '../components/administrators/Template'
import DevelopersJournal from "../components/administrators/DevelopersJournal";
import DevelopersApi from "../components/administrators/components/developpeur/api/DevelopersApi";
import DevelopersApiDoc from "../components/administrators/components/developpeur/DevelopersApiDoc";//intramwallets
import IntramWallet from "../components/administrators/components/intramwallets/IntramWallet";
import PaymentGate from "../components/gates/PaymentGate";

import PaymentGateFirst from "../components/gates/PaymentGateFirst";
import PaymentGateSecond from "../components/gates/PaymentGateSecond";
import InvoiceTemplate from "../components/invoices/invoiceTemplate";
import InvoiceFirst from "../components/invoices/invoiceFirst";
import Transactions from "../components/administrators/Transactions";
import TransactionDetails from "../components/administrators/TransactionDetails";
import SettingTransactionMarchand from "../components/administrators/SettingTransactionMarchand";
import ExchangeHistorique from "../components/administrators/ExchangeHistorique";
import UserAccountHistory from "../components/administrators/UserAccountHistory";
import UserServices from "../components/administrators/user-services/index";
import Newsletters from "../components/administrators/components/Neswletters/Newsletters";
import ListNewsletters from "../components/administrators/components/Neswletters/ListNewsletter";
import Notification from "../components/administrators/Notification";
import ReversementConfigsAdmin from "../components/administrators/components/reversements_perfoms/";
import Reversements from "../components/administrators/components/reversements/Reversements";
import UserMeansPaimentsConfirmaton from "../components/administrators/components/meanspaiements/UserMeansPaimentsConfirmaton";
import UserMeansPaimentsConfirmatonAll from "../components/administrators/components/meanspaiementalls/UserMeansPaimentsConfirmaton";
import newAccountMarchand from "../components/administrators/newAccountMarchand";
import PaycfaCharts from "../components/charts/PaycfaCharts";

import TransfertsClient from "../components/administrators/components/transferts/TransferClient";
import TransfertsGeneral from "../components/administrators/components/transferts/TransferGeneral";
import TransfertsMarchand from "../components/administrators/components/transferts/TransferMarchand";
import Admins from "../components/administrators/components/users/Admins";
import OtherUsers from "../components/administrators/components/users/OtherUsers";
import UserDetails from "../components/administrators/UserDetails";
import MarchandDetails from "../components/administrators/MarchandDetails";
import ParamSetting from "../components/administrators/components/settings/ParamSetting";
import IntramWalletDetails from "@/components/administrators/components/intramwallets/IntramWalletDetails";

import ConditionsUtilisateur from '../components/conditions/conditionsUtilisateur'
import privacyPolicy from '../components/conditions/privacyPolicy'

import NotFound from '../components/errors/404'

/***************** end components imports  ************************/

/***************** intram direct payment  ************************/
import DirectPayment from "../components/intram-direct/home";
import LinksDetails from "../components/intram-direct/LinksDetails";
/***************** intram direct payment  ************************/

/***************** intram business  ************************/
import intramBusiness from "../components/intram-business/home";
import Customers from "@/components/intram-business/Customers";
import ClientCategories from "../components/intram-business/ClientCategories";
import Products from "../components/intram-business/Products";
import MarchandDetailsClient from "../components/intram-business/MarchandDetailsClient";
import MarchandScheduledTransactions from "../components/intram-business/MarchandScheduledTransactions";
import MarchandTransactionDetails from "../components/intram-business/MarchandTransactionDetails";
import LogsPaiement from "../components/intram-business/components/LogsPaiement";
/***************** intram business  ************************/

/***************** intram scholar  ************************/
import intramScholar from "../components/intram-scholar/Home";
import intramScholarClasses from "@/components/intram-scholar/Classes";
import intramScholarManageSchool from '../components/intram-scholar/ManageSchool'
import intramScholarFees from '../components/intram-scholar/Fees'
import intramScholarClassFees from '../components/intram-scholar/ClassFees'
import intramScholarClassStudents from '../components/intram-scholar/ClassStudents'
import intramScholarReductionFees from '../components/intram-scholar/ReductionFees'
import intramScholarStudentDetails from '../components/intram-scholar/StudentDetails'
import intramScholarSettings from '../components/intram-scholar/Settings'
import intramScholarAcademicYears from '../components/intram-scholar/AcademicYears'
import intramScholarInstalments from '../components/intram-scholar/Instalments'
import intramScholarTransactions from '../components/intram-scholar/Transactions'
import intramScholarTransactionDetails from '../components/intram-scholar/TransactionDetails'
import intramScholarLogsPayments from '../components/intram-scholar/components/LogsPayments'
import intramScholarPaymentLogs from '../components/intram-scholar/PaymentLogs'
/***************** intram scholar  ************************/

// import ClientCategories from "../components/intram-business/ClientCategories";
// import Products from "../components/intram-business/Products";
// import MarchandDetailsClient from "../components/intram-business/MarchandDetailsClient";
// import MarchandScheduledTransactions from "../components/intram-business/MarchandScheduledTransactions";
// import MarchandTransactionDetails from "../components/intram-business/MarchandTransactionDetails";
// import LogsPaiement from "../components/intram-business/components/LogsPaiement";
/***************** intram business  ************************/

/******************* intram services */
import intramServices from "../components/administrators/intram-services/Home";
import intramAttributs from "../components/administrators/intram-services/attributes";
import intramSaveAttributs from "../components/administrators/intram-services/saveAttributes";
import intramOptions from "../components/administrators/intram-services/options";
import intramParameters from "../components/administrators/intram-services/settings";
import ServiceAdministrator from "../components/administrators/user-services/setAsAdmin";
/******************* intram services */

/******************* intram ads */
import intramAds from '../components/administrators/intram-ads/Home'
import intramAdCategories from "../components/administrators/intram-ads/Categories";
import intramAdCategoryAttributes from "../components/administrators/intram-ads/CategoryAttributes";
import intramAdDetails from "../components/administrators/intram-ads/AdDetails";
/******************* intram ads */


/******************* intram annuaires */
import intramAnnuaires from '../components/administrators/intram-annuaires/Home'
import intramAnnuaireCategories from "../components/administrators/intram-annuaires/Categories";
import intramAnnuaireCategoryAttributes from "../components/administrators/intram-annuaires/CategoryAttributes";
import intramAnnuaireDetails from "../components/administrators/intram-annuaires/AnnuaireDetails";
/******************* intram annuaires */

/***************** vue components  ************************/
Vue.component('Select2', Select2);
Vue.component('Blank',Blank);
Vue.component('vueSelect',vueSelect);
Vue.component('Home',Home);
Vue.component('Sidebar',Sidebar);
Vue.component('AdminSidebar', AdminSidebar);
Vue.component('MarchandSidebar', MarchandSidebar);
Vue.component('TopSidebar',TopSidebar);
Vue.component('Login',Login);
Vue.component('Register',Register);
Vue.component('CategoryMarchands',CategoryMarchands);
Vue.component('StateMarchands',StateMarchands);
Vue.component('Marchands',Marchands);
Vue.component('UserMeansPaiements',UserMeansPaiements);
Vue.component('Documents',Documents);
Vue.component('Reglages',Reglages);
Vue.component('Devises',Devises);
Vue.component('ListMarchands',ListMarchands);
Vue.component('ReversementConfig');
Vue.component('Newsletters');
Vue.component('ListNewsletters');
Vue.component('PaymentGateFirst',PaymentGateFirst);
Vue.component('PaymentGateSecond',PaymentGateSecond);
Vue.component('InvoiceFirst',InvoiceFirst);
Vue.component('Template',Template);
Vue.component('Notification',Notification);
Vue.component('ReversementConfigsAdmin',ReversementConfigsAdmin);
Vue.component('Reversements',Reversements);
Vue.component('UserMeansPaimentsConfirmaton',UserMeansPaimentsConfirmaton);
Vue.component('paycfa-charts',PaycfaCharts);
Vue.component("RechargeAccount",RechargeAccount);
Vue.component('newAccountMarchand',newAccountMarchand);
Vue.component('Admins',Admins);
Vue.component('OtherUsers',OtherUsers);
Vue.component('Customers',Customers);
Vue.component("ParamSetting",ParamSetting);
Vue.component("IntramWallet",IntramWallet);
Vue.component("IntramWalletDetails",IntramWalletDetails);
Vue.component("ConditionsUtilisateur",ConditionsUtilisateur);
Vue.component("privacyPolicy",privacyPolicy);
Vue.component("logs-paiement",LogsPaiement);
Vue.component("school-logs-payments",intramScholarLogsPayments);
/***************** end vue components  ************************/
 const routes =[
    {
        path: '/',
        name:'dashboard',
        component: Home,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    //errors routes
    {
        path: '*',
        name:'404',
        component: NotFound,
    },
    //auth routes
    {
        path: '/login/:token?',
        name:'Login',
        component: Login,
    },
    {
        path: '/general-conditions-of-use',
        name:'ConditionsUtilisateur',
        component: ConditionsUtilisateur,
    },
    {
        path: '/admin/services',
        name:'intramServices',
        component: intramServices,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/admin/services/options/:service_slug',
        name:'intramOptions',
        component: intramOptions,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/services/parameters/:service_slug',
        name:'intramParameters',
        component: intramParameters,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/services/attributs/:service_slug',
        name:'intramAttributs',
        component: intramAttributs,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/services/save/attributs/:service_slug',
        name:'intramSaveAttributs',
        component: intramSaveAttributs,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/intramDirectPayment',
        name:'intramDirect',
        component: DirectPayment,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/intram/direct/:details',
        name:'links_details',
        component: LinksDetails,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/sheldule-transactions',
        name: 'marchandScheduleTransact',
        component: MarchandScheduledTransactions,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-business',
        name:'intramBusiness',
        component: intramBusiness,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar',
        name:'intramScholar',
        component: intramScholar,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/manage/:school_id',
        name:'intramScholar.manage',
        component: intramScholarManageSchool,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/school/:school_id/settings',
        name:'intramScholar.instalments',
        component: intramScholarInstalments,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/school/:school_id/acedemic-years',
        name:'intramScholar.academic.years',
        component: intramScholarAcademicYears,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/school/:school_id/transactions',
        name:'intramScholar.transactions',
        component: intramScholarTransactions,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/school/:school_id/classes/:class_id/fees',
        name:'intramScholar.class.fees',
        component: intramScholarClassFees,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/payment/:payment_id/logs',
        name:'intramScholar.payment.logs',
        component: intramScholarPaymentLogs,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/classes/:class_id/students',
        name:'intramScholar.class.students',
        component: intramScholarClassStudents,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/school/:school_id/classes',
        name:'intramScholar.classes',
        component: intramScholarClasses,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/school/:school_id/fees',
        name:'intramScholar.fees',
        component: intramScholarFees,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/class/:class_id/student/:student_id/reduction-fees',
        name:'intramScholar.reduction.fees',
        component: intramScholarReductionFees,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intram-scholar/student/:student_id',
        name:'intramScholar.student.details',
        component: intramScholarStudentDetails,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/privacy-policy',
        name:'privacyPolicy',
        component: privacyPolicy,
    },

    {
        path: '/password/reset/:id/:token',
        name:'password.reset',
        component: PasswordReset,
    },
    {
        path: '/register',
        name:'Register',
        component: Register,
    },
    {  path: '/password/forget',
        name:'PasswordForget',
        component: PasswordForget
    },
    //invoice
    {
        path: '/invoice/:transaction_id',
        name:'invoice',
        component: InvoiceTemplate
    },
     //payment gates
    {
        path: '/payment/gate/:transaction_id',
        name:'payment.gate',
        component: PaymentGate
    },
    {
        path: '/transactions/',
        name:'transactions',
        component: Transactions,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/customers/',
        name:'customers',
        component: Customers,
        meta: {
            middleware: [
                auth
            ]
        }
    },

    {
        path: '/all-customers-transactions',
        name:'customerdetails',
        component: MarchandDetailsClient,
        meta: {
            middleware: [
                auth
            ]
        }
    },

    {
        path: '/usermeanspaiments/',
        name:'usermeanspaiments',
        component: UserMeansPaiements,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intramwallets/',
        name:'intramwallets',
        component: IntramWallet,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/intramwallets/:id',
        name:'intramwallets.details',
        component: IntramWalletDetails,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/newAccountMarchand/',
        name:'newAccountMarchand',
        component: newAccountMarchand,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/transferts_client/',
        name:'transferts_client',
        component: TransfertsClient,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/transferts_general/',
        name:'transferts_general',
        component: TransfertsGeneral,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/transferts_marchand/',
        name:'transferts_marchand',
        component: TransfertsMarchand,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/transactions/details/:transaction_id',
        name:'transactions.details',
        component: TransactionDetails,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  
        path: '/marchand/transaction-details/:transaction_id',
        name:'marchandtransactionsdetails',
        component: MarchandTransactionDetails,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/intram-scholar/transaction-details/:transaction_id',
        name:'intramScholar.transaction.details',
        component: intramScholarTransactionDetails,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/intram-scholar/settings/:school_id',
        name:'intramScholar.settings',
        component: intramScholarSettings,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/countries',
        name:'countries',
        component: Country,
        meta: {
            middleware: [
                auth,
            ]
        }
    }, {
        path: '/regions/:country_code?',
        name:'regions',
        component: Region,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/devises',
        name:'devises',
        component: Devises,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/langues',
        name:'langues',
        component: Langues,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/means_paiements',
        name:'meanspaiments',
        component: MeanPaiment,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/users_means_paiement_confirmation',
        name:'usersmeanspaiementconfirmation',
        component: UserMeansPaimentsConfirmatonAll,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/marchandmeansconfirmation/:id',
        name:'marchandmeansconfirmation',
        component: UserMeansPaimentsConfirmaton,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/roles',
        name:'roles',
        component: Roles,
        meta: {
            middleware: [
                auth
            ]
        }
    }
    ,{
        path: '/templates',
        name:'templates',
        component: Template,
        meta: {
            middleware: [
                auth
            ]
        }
    },{
        path: '/notifications',
        name:'notifications',
        component: Notification,
        meta: {
            middleware: [
                auth
            ]
        }
    }
    , {  path: '/villes/:region_code?',
        name:'cities',
        component: Ville,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/marchands/category',
        name:'categorymarchands',
        component: CategoryMarchands,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/marchands/state',
        name:'statemarchands',
        component: StateMarchands,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/document/:id',
        name:'documents',
        component: Documents,
        meta: {
            middleware: [
                auth
            ]
        }
    },{  path: '/transactionsetting/:id',
        name:'transactionsetting',
        component: SettingTransactionMarchand,
        meta: {
            middleware: [
                auth
            ]
        }
    },{  path: '/exchangehistoriques/:id',
        name:'exchangehistoriques',
        component: ExchangeHistorique,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/users',
        name:'users',
        component: Users,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/client_categories',
        name:'categoriesclients',
        component: ClientCategories,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/products',
        name:'products',
        component: Products,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/users/account/histories/:user_id',
        name: "users.histories",
        component: UserAccountHistory,
        meta: {
            middleware: [auth]
        }
    },
 {
        path: '/services/user/:user_id',
        name: "users.services",
        component: UserServices,
        meta: {
            middleware: [auth]
        }
    },
  {
    path: '/services/administrator/:user_id/:marchand_id',
    name: "services.administrator",
    component: ServiceAdministrator,
    meta: {
      middleware: [auth]
    }
  },
 {
        path: '/users/:user_id',
        name: "users.details",
        component: UserDetails,
        meta: {
            middleware: [auth]
        }
    },
    {
        path: '/marchand/:id',
        name: "marchand.details",
        component: MarchandDetails,
        meta: {
            middleware: [auth]
        }
    },

    {  path: '/marchands',
        name:'marchand',
        component: Marchands,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/newsletters',
        name:'newsletters',
        component: Newsletters,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/newsletters/:id',
        name:'newsletters_update',
        component: Newsletters,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/listes/newsletters',
        name:'list_newsletters',
        component: ListNewsletters,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/list_marchands',
        name:'marchands',
        component: ListMarchands,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/reversements/configurations',
        name:'reversements.configs',
        component: ReversementConfig,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/recharges',
        name:'recharges',
        component: RechargeAccount,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/admin/reversements/configurations',
        name:'adminreversements.configs',
        component: ReversementConfigsAdmin,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/reversements/all',
        name:'reversements.get',
        component: Reversements,
        meta: {
            middleware: [
                auth
            ]
        }
    },

    {  path: '/settings',
        name:'settings',
        component: Reglages,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/developers/api',
        name:'api',
        component: DevelopersApi,
        meta: {
            middleware: [
                auth
            ]
        }
    },
     {  path: '/developers/api/documentation',
        name:'developers.api.documentation',
        component: DevelopersApiDoc,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {  path: '/developers/journal',
        name:'developers.journal',
        component: DevelopersJournal,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/admin/ads',
        name:'intramAds',
        component: intramAds,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/admin/ads/categories',
        name:'intramAdCategories',
        component: intramAdCategories,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/ads/categories/:category_slug',
        name:'intramAdCategoryAttributes',
        component: intramAdCategoryAttributes,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/ads/:ad_slug',
        name:'intramAdDetails',
        component: intramAdDetails,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/admin/annuaires',
        name:'intramAnnuaires',
        component: intramAnnuaires,
        meta: {
        middleware: [
            auth
        ]
    }
    },
    {
        path: '/admin/annuaires/categories',
        name:'intramAnnuaireCategories',
        component: intramAnnuaireCategories,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/annuaires/categories/:category_slug',
        name:'intramAnnuaireCategoryAttributes',
        component: intramAnnuaireCategoryAttributes,
        meta: {
        middleware: [
            auth
        ]
    }
    },
     {
        path: '/admin/annuaires/:annuaire_slug',
        name:'intramAnnuaireDetails',
        component: intramAnnuaireDetails,
        meta: {
        middleware: [
            auth
        ]
    }
    },
]

export  default routes;

